// eslint-disable-next-line import/extensions
import mealsFilter from './filterTourProductsByAdditionalFilters/mealsFilter';
import isExclusiveFilter from './filterTourProductsByAdditionalFilters/isExclusiveFilter';
import operatorsFilter from './filterTourProductsByAdditionalFilters/operatorsFilter';
import productTypeFilter from './filterTourProductsByAdditionalFilters/productTypeFilter';
import blockFilter from './filterTourProductsByAdditionalFilters/blockFilter';

export default (filters, tourProducts) => {
    const availableFilters = [{
        filterName: 'productType',
        implementation: productTypeFilter,
    }, {
        filterName: 'isExclusive',
        implementation: isExclusiveFilter,
    }, {
        filterName: 'operators',
        implementation: operatorsFilter,
    }, {
        filterName: 'meals',
        implementation: mealsFilter,
    },{
        filterName: 'block',
        implementation: blockFilter,
    },
];

    return _.filter(tourProducts, (tourProduct) => {
        for (let i = 0; i < availableFilters.length; i++) {
            const availableFilter = availableFilters[i];
            if (!availableFilter.implementation(tourProduct, filters.get(availableFilter.filterName))) {
                return false;
            }
        }
        return true;
    });
};